import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32d0e3b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upgrade-setting-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upgrade-title-box" }, "升级设置", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upgrade-desc-box" }, [
  /*#__PURE__*/_createTextVNode("以下条件至少选择一个，选择多个只需满足一个即可升级。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 自购金额、推广金额需交易完成后才会统计。")
], -1))
const _hoisted_4 = { class: "upgarde-condition-box" }
const _hoisted_5 = { class: "upgarde-condition-item-box" }
const _hoisted_6 = { class: "upgarde-condition-right-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "满", -1))
const _hoisted_8 = {
  key: 0,
  style: {"color":"#f56c6c"}
}
const _hoisted_9 = { class: "upgarde-condition-item-box" }
const _hoisted_10 = { class: "upgarde-condition-right-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "满", -1))
const _hoisted_12 = {
  key: 0,
  style: {"color":"#f56c6c"}
}
const _hoisted_13 = { class: "upgrade-button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ui_form, { ref: "form" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.localValue.isSelfBuy,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.isSelfBuy) = $event)),
                disabled: _ctx.prevValue?.isSelfBuy,
                "true-label": 1,
                "false-label": 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode("自购金额")
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ui_form_item, {
                showError: false,
                style: {"margin":"0"},
                rule: _ctx.validateSelfBuy
              }, {
                default: _withCtx(({ error }) => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _hoisted_7,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.localValue.selfBuyAmount,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.selfBuyAmount) = $event)),
                        disabled: _ctx.localValue.isSelfBuy == 0
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode("元")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    error
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(error.message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["rule"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.localValue.isSalesman,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.isSalesman) = $event)),
                disabled: _ctx.prevValue?.isSalesman,
                "true-label": 1,
                "false-label": 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode("推广金额")
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_ui_form_item, {
                showError: false,
                style: {"margin":"0"},
                rule: _ctx.validateSalesmany
              }, {
                default: _withCtx(({ error }) => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _hoisted_11,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.localValue.salesmanyAmount,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.salesmanyAmount) = $event)),
                        disabled: _ctx.localValue.isSalesman == 0
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode("元")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    error
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(error.message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["rule"])
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.confirm
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}